define("shared/modifiers/show-in-viewport", ["exports", "ember-modifier", "@ember/service", "@ember/debug"], function (_exports, _emberModifier, _service, _debug) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor;

  0; //eaimeta@70e063a35619d71f0,"ember-modifier",0,"@ember/service",0,"@ember/debug"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  /**
   *
   * @class ShowInViewportModifier
   * @extends Modifier
   *
   * This handles watching elements in the viewport
   * that will show the targeted element when the provided element(s) are not in viewport
   * and that will hide the targeted element when the provided element(s) are in viewport
   *
   * Positional Parameters:
   * @param {String} watchedIDs The ids of the element(s) to watch the viewport for, can pass in as many as required as separate strings
   * Elements need to be on the DOM on first load of page.
   *
   * Simple Usage:
   *
   * ```
   * <div id="wholePage">
   *   <div {{show-in-viewport "formThatNeedsAttention" "termsAndConditionsThatNeedReading"}}>
   *    "scroll down to fill out form!"
   *    {{svg-jar "arrow-down"}}
   *   <div>
   * |
   * | way down the page
   * |
   * v
   *   <form id="formThatNeedsAttention">
   *   </form>
   *   <p id="termsAndConditionsThatNeedReading">
   *   </p>
   * </div>
   * ```
   */
  let ShowInViewportModifier = (_class = class ShowInViewportModifier extends _emberModifier.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "inViewport", _descriptor, this);
    }

    get watchedElements() {
      return [...this.args.positional].map(elementID => document.getElementById(elementID));
    }

    didReceiveArguments() {
      this.setup();
    }

    willDestroy() {
      this.tearDown();
    }

    hideElement() {
      this.element.classList.add('u--hide');
    }

    setup() {
      this.watchedElements.forEach(element => {
        (false && !(element) && (0, _debug.assert)("Element must be on the DOM on load of page", element));
        const {
          onEnter,
          onExit
        } = this.inViewport.watchElement(element);
        onEnter(this.hideElement.bind(this));
        onExit(this.showElement.bind(this));
      });
    }

    showElement() {
      this.element.classList.remove('u--hide');
    }

    tearDown() {
      this.watchedElements.forEach(element => this.inViewport.stopWatching(element));
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "inViewport", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  _exports.default = ShowInViewportModifier;
});